module.exports = __webpack_public_path__ + "static/media/PNB.e88abec1.svg";